import React from "react";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import * as settings from "../shared/settingsConstants"

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
  },
  containerLogo: {
    padding: 50,
    backgroundColor: theme.palette.custom ? theme.palette.custom.logoBackgroundColour : settings.portalSettings.logoBackgroundColour
  },
  containerMain: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 50
  },
  logo: {
    height: 50,
    marginRight: "auto",
    marginLeft: "auto",
    display: "block",
  },
  anchor: {
    textDecoration: "none",
    fontSize: "smaller"
  }
}));

function OtherOutlet(props) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <main>
      <CssBaseline />
      <div className={classes.paper}>
        <Container maxWidth="lg">
          <Paper elevation={5}>
            <Container maxWidth="lg" className={classes.containerLogo}>
              <img src={theme.palette.custom ? theme.palette.custom.logoSrc : settings.portalSettings.logoSrc} className={classes.logo} alt="logo" />
            </Container>
            <Container maxWidth="lg" className={classes.containerMain}>
              {props.rootOutlet}
                          <div className="copyright">
                              &copy; <a href="https://www.inscope-aml.com" className="copyright-link">InScope-AML</a> - Self-Service Portal
              </div>
            </Container>
          </Paper>
        </Container>
      </div>
    </main>
  );
}

export default OtherOutlet;
